export default {
    numeroTickets(state) {
        return state.ticketsAbiertos.length
    }
}